export default "__VITE_ASSET__CZftC4Mg__"